export const formatNumber = (value: number) => value.toLocaleString("en-US");
